import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../../common/hook';
import { fetchConfirmData } from "../../../entities/Confirm/modal/featchConfirmData/featchConfirmData";
import { ConfirmResponse } from "../../../entities/Confirm/modal/types/confirm";
import {message} from "antd";

export const ConfirmPage = () => {
    const location = useLocation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [confirmationStatus, setConfirmationStatus] = useState('loading');
    const [messageApi, contextHolder] = message.useMessage();

    const success = (content: string) => {
        messageApi.open({
            type: 'success',
            content,
        });
    };

    const errors = (content: string) => {
        messageApi.open({
            type: 'error',
            content,
        });
    };

    const handleConfirmation = async (key: string) => {
        try {
            const action: any = await dispatch(fetchConfirmData({ key }));
            const data: ConfirmResponse = action.payload;

            setLoading(false);
            if (data.success) {
                setConfirmationStatus('success');
                success(data.message);
                setTimeout(() => {
                    navigate('/');
                }, 1000);
            } else {
                setConfirmationStatus('failure');

                errors(data.message);
                setTimeout(() => {
                    navigate('/');
                }, 1000);
            }
        } catch (error) {
            setLoading(false);
            setConfirmationStatus('error');

            errors('This is an error message');
        }
    };

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const key = searchParams.get('key');
        if (key) {
            handleConfirmation(key)
                .then((result) => {
                    // Handle the result if needed
                })
                .catch((error) => {
                    // Handle errors if any
                });
        }
    }, [dispatch, location.search, navigate]);

    return (
        <div>
            {contextHolder}
        </div>
    );
};

